<template>
    <div>
        <div v-if="!activity" style="color: orange; font-weight: bolder;">
            <span v-if="showIcon"  class="material-icons" style="font-size: 1.6rem; vertical-align: middle; margin-right: .5rem;">
                warning
            </span>

            No Activity
        </div>
        <span v-else-if="isPassedDue(activity)" style="color: crimson; font-weight: bolder;">
            <span v-if="showIcon" class="material-icons" style="font-size: 1.6rem; vertical-align: middle; margin-right: .5rem;">{{ activity | activityIcon }}</span>
            {{ activity.due_at | humanDayTime('MMMM D') }}
        </span>
        <span v-else style="color: green; font-weight: bolder;">
            <span v-if="showIcon" class="material-icons" style="font-size: 1.6rem; vertical-align: middle; margin-right: .5rem;">{{ activity | activityIcon }}</span>
            {{ activity.due_at | humanDayTime('MMMM D') }}
        </span>
    </div>
</template>

<script>
    import Moment from 'moment'
    import Filters from '../../filters'
    import ActivityHelpers from "./ActivityHelpers";

    export default {
        filters: Filters,
        mixins: [ActivityHelpers],
        props: {
            activity: {},
            showIcon: {
                type: Boolean,
                default: true
            }
        },
    }
</script>